import React from 'react';
import { styled } from "@mui/material/styles";
import { Link } from '@mui/material';
import { StatesListProps } from './types';

const Container = styled("div")({});

const StyledTitle = styled("h2")({
    fontSize: "28px",
    fontFamily: "PizzaHutFont",
    fontWeight: "initial"
});

const StyledList = styled("ul")(({ theme }) => ({
    marginBlock: "0",
    paddingInline: "0",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.up("md")]: {
        flexDirection: "row",
        justifyContent: "space-between"
    }
}));

const StyledListItem = styled("li")({
    display: "block",
    marginTop: "15px"
});

const StyledLink = styled(Link)({
    fontSize: "16px"
});

export const StatesList = ({ statesList }: StatesListProps) => {
    const {
        title,
        states
    } = statesList;

    return (
        <Container data-testid="states-list-container">
            <StyledTitle>{title}</StyledTitle>
            <StyledList>
                {states.map((chunk, index) => (
                    <div key={index}>
                        {chunk.map((state, stateIndex) => (
                            <StyledListItem key={stateIndex}>
                                <StyledLink href={state.linkTo}>
                                    {state.linkText}
                                </StyledLink>
                            </StyledListItem>
                        ))}
                    </div>
                ))}
            </StyledList>
        </Container>
    )
};

export default StatesList;